import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useCallback, useEffect } from 'react';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import PropTypes from 'prop-types';

momentDurationFormatSetup(moment);
function Countdown(_ref) {
  var expireTime = _ref.expireTime,
    onExpired = _ref.onExpired,
    onCounting = _ref.onCounting,
    timeFormat = _ref.timeFormat;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    duration = _useState2[0],
    setDuration = _useState2[1];
  var timerRef = useRef(null);
  var calculateDuration = useCallback(function () {
    var now = moment();
    var expireTimeMoment = moment(expireTime);
    if (expireTimeMoment.isBefore(now)) {
      onExpired();
      return null;
    }
    onCounting();
    return moment.duration(Math.floor(expireTimeMoment.diff(now))).format(timeFormat, {
      trim: false
    });
  }, [expireTime]);
  var timerCallback = useCallback(function () {
    setDuration(calculateDuration());
  }, [calculateDuration]);
  useEffect(function () {
    timerRef.current = setInterval(timerCallback, 1000);
    return function () {
      clearInterval(timerRef.current);
    };
  }, [expireTime]);
  if (!duration) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, duration);
}
Countdown.propTypes = {
  expireTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]).isRequired,
  onExpired: PropTypes.func,
  onCounting: PropTypes.func,
  timeFormat: PropTypes.string
};
Countdown.defaultProps = {
  onExpired: function onExpired() {},
  onCounting: function onCounting() {},
  timeFormat: 'mm:ss'
};
Countdown.displayName = 'Countdown';
var Countdown$1 = /*#__PURE__*/React__default.memo(Countdown);

export { Countdown$1 as default };
